<template>
	<div class="container">
		<div class="intro1-tit">
			<div class="wl"></div>
			<span>知识能力</span>
		</div>
		<div class="one">
			<div class="schoolWZ" v-for="(item,index) in crumbs" :key="index+1">
				<div class="SCLeft">
					<span>{{item.title}}</span>
				</div>
				<div class="SCbottom">
					<el-breadcrumb separator="">
						<!--  -->
						<el-breadcrumb-item v-for="(item1,index2) in item.Cont" :key="index2+2"><a @click="isT(index2)"
								:class=" isTrue == index2 ? 'active' :''">{{item1.cont1}}</a>
						</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
			</div>
			<div class="em"></div>
			<div class="schoolWZ" v-for="(itemA,index3) in crumbs1" :key="index3+3">
				<div class="SCLeft">
					<span>{{itemA.title}}</span>
				</div>
				<div class="SCbottom">
					<el-breadcrumb separator="">
						<el-breadcrumb-item v-for="(itemA1,index4) in itemA.Cont" :key="index4+4"><a
								@click="isT1(index4)" :class=" isTrue1 == index4 ? 'active' :''">{{itemA1.cont1}}</a>
						</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
			</div>
			<div class="em1"></div>
			<div class="schoolWZ" v-for="(itemB,index5) in crumbs2" :key="index5+5">
				<div class="SCLeft">
					<span>{{itemB.title}}</span>
				</div>
				<div class="SCbottom">
					<el-breadcrumb separator="">
						<el-breadcrumb-item v-for="(itemB1,index6) in itemB.Cont" :key="index6+6"><a
								@click="isT2(index6)" :class=" isTrue2 == index6 ? 'active' :''">{{itemB1.cont1}}</a>
						</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
			</div>
			<div class="em1"></div>
			<div class="schoolWZ" v-for="(itemC,index7) in crumbs3" :key="index7+7">
				<div class="SCLeft">
					<span>{{itemC.title}}</span>
				</div>
				<div class="SCbottom">
					<el-breadcrumb separator=" ">
						<el-breadcrumb-item v-for="(itemC1,index8) in itemC.Cont" :key="index8+8"><a
								@click="isT3(index8)" :class=" isTrue3 == index8 ? 'active' :''">{{itemC1.cont1}}</a>
						</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
			</div>
			
			<div class="em1"></div>
			<div class="schoolWZ" v-for="(itemD,index9) in crumbs4" :key="index9+9">
				<div class="SCLeft">
					<span>{{itemD.title}}</span>
				</div>
				<div class="SCbottom">
					<el-breadcrumb separator=" ">
						<el-breadcrumb-item v-for="(itemD1,index10) in itemD.Cont" :key="index10+10"><a
								@click="isT4(index10)" :class=" isTrue4 == index10 ? 'active' :''">{{itemD1.cont1}}</a>
						</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
			</div>
			
			<div class="em1"></div>
			<div class="schoolWZ" v-for="(itemE,index11) in crumbs5" :key="index11+11">
				<div class="SCLeft">
					<span>{{itemE.title}}</span>
				</div>
				<div class="SCbottom">
					<el-breadcrumb separator=" ">
						<el-breadcrumb-item v-for="(itemE1,index11) in itemE.Cont" :key="index11+11"><a
								@click="isT5(index11)" :class=" isTrue5 == index11 ? 'active' :''">{{itemE1.cont1}}</a>
						</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
			</div>
			
			
		</div>
	</div>

</template>
<script>
	export default {
		props: [],
		components: {},
		data() {
			return {
				isTrue: 0,
				isTrue1: 0,
				isTrue2: 0,
				isTrue3: 0,
				isTrue4: 0,
				isTrue5: 0,
				// 面包屑渲染
				crumbs: [{
					title: '专业类别：',
					Cont: [{
							cont1: '不限'
						},
						{
							cont1: '资源环境与安全'
						},
						{
							cont1: '能力原动力与材料'
						},
						{
							cont1: '土木建筑'
						},
						{
							cont1: '水利'
						},
						{
							cont1: '装备制造'
						},
						{
							cont1: '生物与化工'
						},
						{
							cont1: '文化艺术'
						},
						{
							cont1: '新闻传播'
						},
						{
							cont1: '教育与体育'
						},
						{
							cont1: '公司与安法'
						},
						{
							cont1: '公共管理与服务'
						},
						{
							cont1: '农林牧渔'
						}

					]
				}],
				crumbs1: [{
					title: '专业大类：',
					Cont: [{
							cont1: '不限'
						},
						{
							cont1: '农业类'
						},
						{
							cont1: '林业类'
						},
						{
							cont1: '畜牧业类'
						},
						{
							cont1: '渔业类'
						},
						{
							cont1: '畜牧兽医类'
						},
						{
							cont1: '水产养殖类'
						},

					]
				}],
				crumbs2: [{
					title: '院校位置：',
					Cont: [{
							cont1: '不限'
						},
						{
							cont1: '山东省'
						},
						{
							cont1: '河南省'
						},
						{
							cont1: '河北省'
						},
						{
							cont1: '山西省'
						},
						{
							cont1: '安徽省'
						},
						{
							cont1: '北京市'
						},
						{
							cont1: '天津市'
						},
						{
							cont1: '上海市'
						},
						{
							cont1: '重庆市'
						},
						{
							cont1: '江西省'
						},
						{
							cont1: '江苏省'
						},
						{
							cont1: '浙江省'
						},
						{
							cont1: '湖南省'
						},
						{
							cont1: '湖北省'
						},
						{
							cont1: '广东省'
						},
						{
							cont1: '云南省'
						},
						{
							cont1: '贵州省'
						},
						{
							cont1: '四川省'
						},
						{
							cont1: '陕西省'
						},
						{
							cont1: '青海省'
						},
						{
							cont1: '黑龙江'
						},
						{
							cont1: '吉林省'
						},
						{
							cont1: '辽宁省'
						},
						{
							cont1: '福建省'
						},
						{
							cont1: '广西省'
						},
						{
							cont1: '海南省'
						},
						{
							cont1: '甘肃省'
						},
						{
							cont1: '内蒙古'
						},
						{
							cont1: '新 疆'
						},
						{
							cont1: '宁 夏'
						},
						{
							cont1: ''
						}
					]
				}],
				crumbs3: [{
					title: '院校类型：',
					Cont: [{
							cont1: '不限'
						},
						{
							cont1: '工科'
						},
						{
							cont1: '农业'
						},
						{
							cont1: '医药'
						},
						{
							cont1: '政法'
						},
						{
							cont1: '师范'
						},
						{
							cont1: '财经'
						},
						{
							cont1: '民族'
						},
						{
							cont1: '语言'
						},
						{
							cont1: '艺术'
						},
						{
							cont1: '军事'
						},
						{
							cont1: '体育'
						},
						{
							cont1: '其他'
						},
						{
							cont1: ''
						}
					]
				}],
				crumbs4: [{
					title: '院校隶属：',
					Cont: [{
							cont1: '不限'
						},
						{
							cont1: '教育部'
						},
						{
							cont1: '工业和信息化部'
						},
						{
							cont1: '国家卫生和计划生育委员会'
						},
						{
							cont1: '国家体育馆'
						},
						{
							cont1: '国家民族事务'
						},
						{
							cont1: ''
						}
					]
				}],
				crumbs5: [{
					title: '院校级别：',
					Cont: [{
							cont1: '不限'
						},
						{
							cont1: '985'
						},
						{
							cont1: '211'
						},
						{
							cont1: '211'
						},
						{
							cont1: '双一流'
						},
						{
							cont1: '研究生院'
						},
						{
							cont1: '全国重点'
						},
						{
							cont1: ''
						}
					]
				}],
			};
		},
		computed: {},
		methods: {
			isT(index) {
				this.isTrue = index;
			},
			isT1(index) {
				this.isTrue1 = index;
			},
			isT2(index) {
				this.isTrue2 = index;
			},
			isT3(index) {
				this.isTrue3 = index;
			},
			isT4(index) {
				this.isTrue2 = index;
			},
			isT5(index) {
				this.isTrue2 = index;
			}
		},
		mounted() {},
	};
</script>
<style scoped>
	.intro1-tit{
		display: flex;
		margin-bottom: 15px;
	}
	.intro1-tit span {
		margin-left: 10px;
		font-size: 20px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #333333;
		line-height: 20px;
		display: flex;
		align-items: center;
	}
	.wl {
		width: 6px;
		height: 22px;
		border-radius: 0px 4px 4px 0px;
		background: #F21323;
	}
	.one {
		margin-top: 20px;
		justify-content: space-around;
		width: 100%;
		background: rgba(255, 255, 255, 0.39);
		box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.16);
		opacity: 1;
		border-radius: 5px;
		display: flex;
		flex-direction: column;
		padding: 20px;
	}

	.one span {
		line-height: 50px;
		margin-right: 8px;
	}

	.schoolWZ {
		width: 100%;
		height: auto;
		display: flex;
	}

	.schoolWZ .SCLeft {
		width: 115px;
	}

	.schoolWZ .SCmain {
		width: 64px;
		height: 60px;
		margin-right: 15px;
		margin-top: 10px;
	}

	.schoolWZ .SCmain a {
		display: block;
		text-align: center;
		line-height: 32px;
		font-weight: 600;
		height: 32px;
		color: #333333;
		opacity: 1;
		cursor: pointer;
		font-size: 14px;
		margin: 0 10px;
	}

	.active {
		background: #e63233;
		color: #fff !important;
		border-radius: 16px;
		padding: 6px 11px;
		box-sizing: border-box;
	}

	.schoolWZ .SCbottom {
		width: 100%;
		text-align: left;
	}

	.schoolWZ .SCbottom a {
		text-decoration: none;
		cursor: pointer;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 600;
		line-height: 20px;
		color: #333333;
		opacity: 1;
	}

	/* 设置个别宽度不是以下不是此范围的样式 */
	@media (min-width: 1400px) {
		.container {
			width: 1458px;
		}
	}

	.em {
		width: 1140px;
		height: 1px;
		margin-left: 93px;
		margin-top: 30px;
		margin-bottom: 30px;
		border-bottom: 1px #eee9e9 solid;
	}

	.em1 {
		width: 1140px;
		height: 1px;
		margin-left: 93px;
		margin-bottom: 10px;
		border-bottom: 1px #eee9e9 solid;
	}

	@media (max-width: 750px) {
		body {
			width: 100%;
			height: auto;
		}

		.em {
			width: 100%;
			margin-left: 0;
		}

		.em1 {
			width: 100%;
			margin-left: 0;
		}

		.schoolWZ .SCLeft {
			width: 134px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/saixuantop3.vue